import api from './axios';

export interface SchemaMasterConfig {
  companyId: string | null;
  companyName: string | null;
  companyCode: string | null;
  databaseName: string | null;
  lastDumpAt: string | null;
  defaultTemplateModifiedAt: string | null;
  hasMigrationsNewerThanTemplate: boolean;
}

export const schemaTemplatesApi = {
  getMaster: () =>
    api.get<SchemaMasterConfig>('/super-admin/global-settings/schema-master').then((r) => r.data),

  setMaster: (companyId: string | null) =>
    api.put('/super-admin/global-settings/schema-master', { companyId }).then(() => undefined),
};
